import { fg } from '@atlassian/jira-feature-gating';

const JiraInviteButtonRelayProvider = {
	get(): boolean {
		return fg('jfind-restore-invite-button-gate');
	},
};

export default JiraInviteButtonRelayProvider;
